module.exports = __webpack_public_path__ + "marker-grey.svg?b8b732d6fa5340c89f2acb9c69bc2852";